const searchStrip = {
  hotels: "होटल", // translated 
  city: "शहर", // translated 
  checkIn: "चेक इन", // translated 
  checkOut: "चेक आउट", // translated 
  date: "तारीख", // translated 
  persons: "व्यक्तियों", // translated 
  adults: "वयस्कों", // translated 
  rooms: "कमरा", // translated 
  editSearch: "खोज संपादित करें", // translated 
  newSearch: "नई खोज", // translated 
  listView: "लिस्ट व्यू", // translated 
  mapView: "मानचित्र दृश्य", // translated 
};


export default searchStrip;
